// One short institution name everywhere, so "E*TRADE from Morgan Stanley" reads "E*TRADE".
export const shortInstitutionName = (institution: string): string =>
  institution.split(/\s+from\s+/i)[0].trim() || institution
